import { request } from '@/shared/api/request'

export const sendEmployerSignedXml = (signedXml) => {
	return request({ url: 'colcontract/ecd/employer/sign', method: 'POST', data: signedXml })
}
